export default __webpack_public_path__ + "static/media/radio.1a2e750f.svg";